import PropTypes from "prop-types";

const PriceFormat = props =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  }).format(props.value);

export default PriceFormat;

PriceFormat.propTypes = {
  value: PropTypes.number
};
